import React, { useState, useRef, useEffect } from 'react';
import { Dialog, Stack, Typography, DialogActions, Button, IconButton, TextField, useTheme, MenuItem, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import * as yup from 'yup';
import { Formik, Form } from 'formik';
import { matchIsValidTel } from 'mui-tel-input';

import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import appapi from '../../../../api/apiClient';
import { showmessage } from '../../../../utils/toastr';
import { setLoading } from '../../../../redux/features/appSlice';
import { useSelector, useDispatch } from 'react-redux';
import FormTextField from '../../../../components/FormTextField';
import Transition from '../../../../components/Transition';
import ModalHeader from '../../../../components/ModalHeader';
import FormSelectField from '../../../../components/FormSelectField';
import PhoneTextField from '../../../../components/PhoneTextField';

/**
 * dialog style
 */
const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100%)',
    // overflow: 'hidden'
  },
};

/**
 * Validation Schema
 */
const validationSchema = yup.object({
  displayName: yup.string('Display Name').min(3, 'Display Name should be atleast 3 characters').max(30, 'Maximum Character Limit 30').required(' '),
  companyName: yup.string('Company Name').min(3, 'Company Name should be atleast 3 characters').max(100, 'Maximum Character Limit 100').required(' '),
  regAddress: yup.string('Company Name').min(1, 'Company Name should be atleast 3 characters').max(300, 'Maximum Character Limit 300').required(' '),
  countryName: yup.string('Country Name').required(' '),
  stateName: yup.string('state Name').required(' '),
  companyWebsite: yup
    .string()
    .nullable()
    .matches(/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi, 'Enter valid url!'),
  entityType: yup.string('Entity Type').notRequired(),
  entityTypeSpecify: yup.string().when(['entityType'], {
    is: (entityType) => {
      //any complex calulation
      return entityType === 'others';
    },
    then: yup.string().required(),
  }),
  companyType: yup.string('Company Type').required(),
  clientType: yup.string('Client Type').required(),
  noOfVessals: yup.number('Number of vessals').required(),
  adminName: yup.string('Admin Name').required(' ').min(3, 'Admin Name should be atleast 3 characters').max(50, 'Maximum Character Limit 50'),
  emailId: yup
    .string('EMail ID')
    .matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'Email is Invalid')
    .trim()
    .nullable()
    .required(' '),
  adminDesignation: yup.string('Admin Designation').required(' ').min(3, 'Admin Designation should be atleast 3 characters').max(50, 'Maximum Character Limit 50'),
  phone: yup
    .string('Phone Number')
    .required()
    .test('is-valid-number', 'Mobile Number is Invalid', (value) => {
      if (value) {
        return matchIsValidTel(value);
      }

      return false;
    }),
  traderListAccess: yup.string('Trader list access'),
});

const entityTypes = [
  {
    entityId: 'private',
    entityName: 'Private',
  },
  {
    entityId: 'public',
    entityName: 'Public',
  },
  {
    entityId: 'others',
    entityName: 'Others',
  },
];

const companyType = [
  {
    companyId: 'ship manager',
    companyName: 'Ship Manager',
  },
  {
    companyId: 'ship owner',
    companyName: 'Ship Owner',
  },
  {
    companyId: 'charterer',
    companyName: 'Charterer',
  },
  {
    companyId: 'operator',
    companyName: 'Operator',
  },
];

const clientType = [
  {
    clientId: 'cwclient',
    clientName: 'CW Client',
  },
  {
    clientId: 'bossclient',
    clientName: 'BOSS Client',
  },
];

export default function AddEditCompany({ companyDetails, onModelHandleClose, modelOpen }) {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { userId } = useSelector((state) => state.auth);
  const { countryList } = useSelector((state) => state.layout);
  const [countryId, setCountryId] = useState(null);
  const [stateList, setStateList] = useState([]);
  const [traderDownList, setTraderList] = useState([]);

  useEffect(() => {
    if (companyDetails.countryName) {
      const idObj = countryList.filter((res) => res.countryName === companyDetails.countryName)[0];
      if (idObj) {
        setCountryId(idObj._id);
      }
    }
  }, [companyDetails.countryName]);

  useEffect(() => {
    if (countryId) {
      getStateList();
    }
  }, [countryId]);

  // useEffect(() => {
  //   getTraderList();
  // }, []);

  const getStateList = async () => {
    const response = await appapi.get(`common/state/${countryId}`);
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setStateList(data.response || []);
      } else {
        setStateList([]);
      }
    }
  };

  // const getTraderList = async () => {
  //   const response = await appapi.get(`trader/traderListDropDown`);
  //   if (response.ok) {
  //     const data = response.data;
  //     if (data.status === '7400') {
  //       setTraderList(data.response || []);
  //     } else {
  //       setTraderList([]);
  //     }
  //   }
  // };

  const handleClose = () => {
    onModelHandleClose(false);
  };

  const handleAddCompany = async (values) => {
    dispatch(setLoading(true));
    const payload = values;
    if (values.entityType === 'others') {
      payload['entityType'] = values.entityTypeSpecify;
    }
    payload['traderListAccess'] = values.traderListAccess === '1';
    delete payload['entityTypeSpecify'];

    const response = await appapi.post(`/company`, payload);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true);
        showmessage(data.message);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
    console.log(payload, 'payload');
  };

  const handleEditCompany = async (values) => {
    const payload = { ...values };
    if (values.entityType === 'others') {
      payload['entityType'] = values.entityTypeSpecify;
    }
    payload['traderListAccess'] = values.traderListAccess === '1';
    payload['adminId'] = companyDetails?.adminId;
    dispatch(setLoading(true));
    const response = await appapi.put(`company/${companyDetails?._id}`, payload);
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true);
        showmessage(data.message);
        // dispatch(initGodownList());
      } else {
        showmessage(data.message, 'error');
      }
      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  const entityType = companyDetails?.entityType ? (companyDetails?.entityType === 'private' || companyDetails?.entityType == 'public' ? companyDetails?.entityType : 'others') : undefined;

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      // TransitionComponent={Transition}
      PaperProps={{ sx: { position: 'fixed', top: 0, right: 0, m: 0 } }}
    >
      <Stack
        // className="!h-[100%]"
        style={{ backgroundColor: '#F0F0F0' }}
      >
        <ModalHeader
          label={`${companyDetails?.type === 'add' ? 'ADD' : 'EDIT'} COMPANY`}
          onClose={() => onModelHandleClose(false)}
        />
        <Formik
          innerRef={formRef}
          enableReinitialize={false}
          initialValues={{
            superAdminId: userId,
            displayName: companyDetails?.displayName ? companyDetails?.displayName : '',
            companyName: companyDetails?.companyName ? companyDetails?.companyName : '',
            regAddress: companyDetails?.regAddress ? companyDetails?.regAddress : '',
            countryName: companyDetails?.countryName ? companyDetails?.countryName : undefined,
            stateName: companyDetails?.stateName ? companyDetails?.stateName : undefined,
            companyWebsite: companyDetails?.companyWebsite ? companyDetails?.companyWebsite : null,
            companyType: companyDetails?.companyType ? companyDetails?.companyType : undefined,
            noOfVessals: companyDetails?.noOfVessals ? companyDetails?.noOfVessals : undefined,
            entityType: entityType,
            // traderId: companyDetails?.traderId ? companyDetails?.traderId : [],
            adminName: companyDetails?.name ? companyDetails?.name : undefined,
            emailId: companyDetails?.email ? companyDetails?.email : undefined,
            adminDesignation: companyDetails?.designation ? companyDetails?.designation : undefined,
            phoneNumber: companyDetails?.phoneNumber ? companyDetails?.phoneNumber : '',
            phoneCode: companyDetails?.phoneCode ? companyDetails?.phoneCode : '',
            phone: (companyDetails?.phoneCode || '') + (companyDetails?.phoneNumber || ''),
            entityTypeSpecify: companyDetails?.entityType ? (companyDetails?.entityType === 'private' || companyDetails?.entityType === 'public' ? undefined : companyDetails?.entityType) : undefined,
            traderListAccess: companyDetails?.traderListAccess || '1',
            clientType: companyDetails?.clientType ? companyDetails?.clientType : '',
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            if (companyDetails?.type === 'add') {
              handleAddCompany(values);
            } else {
              handleEditCompany(values);
            }
          }}
        >
          {({ values, errors, isValid, dirty, setFieldValue, setFieldError }) => (
            <Form autoComplete="off">
              <Stack
                style={{ backgroundColor: 'white', borderRadius: '8px' }}
                className="m-[15px] p-[16px]"
              >
                <Typography
                  className="fw-medium ff-Roboto fs-14"
                  style={{ marginBottom: '20px' }}
                >
                  Company details
                </Typography>
                <Stack>
                  <FormTextField
                    placeholder={'Display Name'}
                    outlineLabel={'Display Name'}
                    name="displayName"
                    requiredMark={true}
                    allowAlphaNumeric={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 101 }}
                  />
                </Stack>
                <Stack>
                  <FormTextField
                    placeholder={'Company Name'}
                    outlineLabel={'Company Name'}
                    name="companyName"
                    requiredMark={true}
                    // allowAlphaNumeric={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 101 }}
                  />
                </Stack>
                <Stack>
                  <FormTextField
                    placeholder={'Address'}
                    outlineLabel={'Address'}
                    name="regAddress"
                    requiredMark={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 301 }}
                  />
                </Stack>
                <Stack>
                  <FormSelectField
                    name="countryName"
                    label={'Country *'}
                    onSelect={(e) => {
                      setFieldValue('stateName', undefined);
                      const idObj = countryList.filter((res) => res.countryName === e)[0];
                      if (idObj) {
                        setCountryId(idObj._id);
                      }
                    }}
                  >
                    {countryList?.map((item) => (
                      <MenuItem
                        key={item.countryName}
                        value={item.countryName}
                      >
                        <div style={{ textTransform: 'capitalize' }}>{item.countryName}</div>
                      </MenuItem>
                    ))}
                  </FormSelectField>
                </Stack>
                <Stack>
                  <FormSelectField
                    name="stateName"
                    label={'State *'}
                  >
                    {stateList?.length === 0 && (
                      <MenuItem
                        disabled
                        value=""
                      >
                        <em>No Data Found</em>
                      </MenuItem>
                    )}
                    {stateList?.map((item) => (
                      <MenuItem
                        key={item.stateName}
                        value={item.stateName}
                      >
                        <div style={{ textTransform: 'capitalize' }}>{item.stateName}</div>
                      </MenuItem>
                    ))}
                  </FormSelectField>
                </Stack>
                <Stack>
                  <FormTextField
                    placeholder={'Website'}
                    outlineLabel={'Website'}
                    name="companyWebsite"
                    requiredMark={false}
                    whiteSpace={true}
                    lowerCase={true}
                    inputProps={{ maxLength: 200 }}
                  />
                </Stack>

                <Stack>
                  <FormTextField
                    outlineLabel={'Company Type'}
                    fullWidth
                    id={'companyType'}
                    name="companyType"
                    requiredMark={true}
                    select
                    sx={{ marginBottom: '25px !important' }}
                    onSelect={(e) => {}}
                  >
                    {companyType?.map((item) => (
                      <MenuItem
                        key={item.companyId}
                        value={item.companyId}
                      >
                        {item.companyName}
                      </MenuItem>
                    ))}
                  </FormTextField>
                </Stack>
                <Stack>
                  <FormTextField
                    disabled={companyDetails.clientType ? true : false}
                    outlineLabel={'Client Type'}
                    fullWidth
                    id={'clientType'}
                    name="clientType"
                    requiredMark={true}
                    select
                    sx={{ marginBottom: '25px !important' }}
                    onSelect={(e) => {
                      if(e === 'bossclient') {
                        setFieldValue('traderListAccess', 1 );
                      }
                    }}
                  >
                    {clientType?.map((item) => (
                      <MenuItem
                        key={item.clientId}
                        value={item.clientId}
                      >
                        {item.clientName}
                      </MenuItem>
                    ))}
                  </FormTextField>
                </Stack>

                <Stack sx={{ marginBottom: '22px', marginLeft: '16px' }}>
                  <FormControl>
                    <FormLabel
                      id="accessToList"
                      style={{ color: '#5A688B' }}
                    >
                      Access To Trader’s List *
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={values.traderListAccess}
                      onChange={(e) => {
                        setFieldValue('traderListAccess', e.target.value);
                      }}
                    >
                      <FormControlLabel
                        value={'1'}
                        control={<Radio />}
                        label="Yes"
                        disabled={values?.clientType === 'bossclient'}
                      />
                      <FormControlLabel
                        value={'0'}
                        control={<Radio />}
                        label="No"
                        disabled={values?.clientType === 'bossclient'}
                      />
                    </RadioGroup>
                  </FormControl>
                </Stack>
                
                <Stack>
                  <FormTextField
                    outlineLabel={'No of Vessals'}
                    name="noOfVessals"
                    requiredMark={true}
                    onlyNumber={true}
                    inputProps={{ maxLength: 5 }}
                  />
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={'Entity type'}
                    fullWidth
                    id={'entityType'}
                    name="entityType"
                    requiredMark={false}
                    select
                    sx={{ marginBottom: '25px !important' }}
                    onSelect={(e) => {
                      if (e !== 'others') {
                        setFieldValue('entityTypeSpecify', '');
                      }
                    }}
                  >
                    {entityTypes?.map((item) => (
                      <MenuItem
                        key={item.entityId}
                        value={item.entityId}
                      >
                        {item.entityName}
                      </MenuItem>
                    ))}
                  </FormTextField>
                </Stack>
                {values.entityType === 'others' && (
                  <Stack>
                    <FormTextField
                      outlineLabel={'Specify Entity Type'}
                      name="entityTypeSpecify"
                      requiredMark={true}
                      onlyAlpha={true}
                      whiteSpace={true}
                      inputProps={{ maxLength: 200 }}
                    />
                  </Stack>
                )}
              </Stack>
              <Stack
                style={{ backgroundColor: 'white', borderRadius: '8px' }}
                className="m-[15px] p-[16px]"
              >
                <Typography
                  className="fw-medium ff-Roboto fs-14"
                  style={{ marginBottom: '20px' }}
                >
                  Admin Information
                </Typography>
                <Stack>
                  <FormTextField
                    outlineLabel={'Name'}
                    name="adminName"
                    requiredMark={true}
                    onlyAlpha={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 51 }}
                  />
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={'Designation'}
                    name="adminDesignation"
                    requiredMark={true}
                    onlyAlpha={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 51 }}
                  />
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={'Email Id'}
                    name="emailId"
                    requiredMark={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 50 }}
                    lowerCase={true}
                  />
                </Stack>
                <Stack>
                  <PhoneTextField
                    required
                    variant="outlined"
                    label="Phone No"
                    name="phone"
                    name2="phoneNumber"
                    name3="phoneCode"
                  />
                </Stack>
              </Stack>

              <DialogActions
                className="!mt-[44px] h-[66px] !justify-end p-[0px] sticky bottom-[0]"
                style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
              >
                <Button
                  sx={[
                    dialogButtonCancel,
                    {
                      color: theme.palette.primary.main,
                      borderColor: '#14285A33',
                      backgroundColor: '#14285A1A',
                      '&:hover': {
                        // backgroundColor: theme.palette.secondary.main,
                        // color: theme.palette.background.main,
                        // borderColor: theme.palette.secondary.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', marginLeft: '80px', height: '40px' }}
                  variant="outlined"
                  onClick={() => {
                    handleClose();
                    //   setConfirmVal('');
                  }}
                >
                  Cancel
                </Button>
                <Button
                  sx={[
                    buttonStyle2,
                    {
                      color: theme.palette.background.main,
                      backgroundColor: theme.palette.primary.dark,
                      '&:hover': {
                        // backgroundColor: theme.palette.secondary.main,
                        // color: theme.palette.background.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', height: '40px' }}
                  disabled={!(dirty && isValid)}
                  type="submit"
                  variant="contained"
                >
                  {companyDetails?.type === 'add' ? `ADD` : `UPDATE`}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Stack>
    </Dialog>
  );
}
